import { render } from "./CVView.vue?vue&type=template&id=1d0788df&scoped=true"
import script from "./CVView.vue?vue&type=script&lang=js"
export * from "./CVView.vue?vue&type=script&lang=js"

import "./CVView.vue?vue&type=style&index=0&id=1d0788df&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d0788df"]])

export default __exports__